/**
 * LEGACY Analytics
 * Reimport all dkt-footer JS files
 */

// FRAMEWORK
import './legacy/framework/AnalyticsConstants.legacy';
import './legacy/framework/Analytics.legacy';
import './legacy/framework/anly-trackers.legacy';
import './legacy/framework/anly-datalayer.legacy';
import './legacy/framework/anly-enhanced.legacy';
import './legacy/framework/anly-queue.legacy';
import './legacy/framework/anly-server-side.legacy';
import './legacy/framework/anly-shopping-tool.legacy';
import './legacy/framework/anly-debug.legacy';
import './legacy/framework/anly-colorama.legacy';
import './legacy/framework/anly-plv2.legacy';
import './legacy/framework/anly-panoply.legacy';
import './legacy/framework/anly-utils.legacy';

// FWK Utilities
import './legacy/framework/utils/anly-utils-homepage.legacy';
import './legacy/framework/utils/anly-utils-pagelist.legacy';
import './legacy/framework/utils/anly-utils-productpage.legacy';
import './legacy/framework/utils/anly-utils-sportpage.legacy';
import './legacy/framework/utils/anly-utils-basketpage.legacy';
import './legacy/framework/utils/anly-utils-datalayer.legacy';
import './legacy/framework/utils/anly-utils-suggestions.legacy';
import './legacy/framework/utils/anly-utils-perso.legacy';

// FWK Classes
import './legacy/framework/AnalyticsTracker.legacy';
import './legacy/framework/events/AnalyticsEvent.legacy';
import './legacy/framework/events/AnalyticsTriggerEvent.legacy';
import './legacy/framework/events/AnalyticsClickEvent.legacy';
import './legacy/framework/events/AnalyticsConditionalEvent.legacy';
import './legacy/framework/events/AnalyticsSlickEvent.legacy';
import './legacy/framework/events/AnalyticsQueueEvent.legacy';

// // SHOPPING TOOL
import './shopping-tool/st-save-later';

// LVP
import './legacy/perso/lvp.legacy';
import './legacy/perso/lvp-history.legacy';

// ANALYTICS INIT
import './legacy/framework/anly-init.legacy';

// PERSONALIZATION
import './legacy/personalization/framework/PersonalizationConstants.legacy';
import './legacy/personalization/framework/Personalization.legacy';



// WEBPACK FOOTER //
// ./src/analytics/analytics.entry.js